import ApplicationChatMessage from './ApplicationChatMessage'
import FileChatMessage from './FileChatMessage'
import GigDisputeChatMessage from './GigDisputeChatMessage'
import GigMarkedDoneChatMessage from './GigMarkedDoneChatMessage'
import GigOfferChatMessage from './GigOfferChatMessage'
import GigRefundedChatMessage from './GigRefundedChatMessage'
import GigReviewChatMessage from './GigReviewChatMessage'
import GigUnavailableChatMessage from './GigUnavailableChatMessage'
import ImageChatMessage from './ImageChatMessage'
import JobDisputeChatMessage from './JobDisputeChatMessage'
import JobMarkedDoneChatMessage from './JobMarkedDoneChatMessage'
import JobOfferChatMessage from './JobOfferChatMessage'
import JobRefundedChatMessage from './JobRefundedChatMessag'
import JobReviewChatMessage from './JobReviewChatMessage'
import JobRoomUnlockedChatMessage from './JobRoomUnlockedChatMessage'
import JobUnavailableChatMessage from './JobUnavailableChatMessage'
import RoomClosedChatMessage from './RoomClosedChatMessage'
import SystemChatMessage from './SystemMessage'
import TextChatMessage from './TextChatMessage'
import UserBannedChatMessage from './UserBannedChatMessage'
import VacancyApplicationAppliedChatMessage from './VacancyApplicationAppliedChatMessage'
import VacancyApplicationDeclinedChatMessage from './VacancyApplicationDeclinedChatMessage'
import VacancyArchivedChatMessage from './VacancyArchivedChatMessage'
import VacancyRemovedChatMessage from './VacancyRemovedChatMessage'
import VacancyUnavailableChatMessage from './VacancyUnavailableChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default function chatMessageFactory(message: LX.ChatMessage) {
  switch (message?.type) {
    case MessageTypes.TEXT:
      return 'body' in message && typeof message.body === 'object'
        ? ApplicationChatMessage.fromServer(message as LX.ApplicationChatMessage)
        : TextChatMessage.fromServer(message as LX.TextChatMessage)
    case MessageTypes.LINK:
      return TextChatMessage.fromServer(message as LX.TextChatMessage)
    case MessageTypes.IMAGE:
      return ImageChatMessage.fromServer(message as LX.ImageChatMessage)
    case MessageTypes.FILE:
      return FileChatMessage.fromServer(message as LX.FileChatMessage)
    case MessageTypes.JOB_OFFER:
      return JobOfferChatMessage.fromServer(message as LX.JobOfferChatMessage)
    case MessageTypes.GIG_OFFER:
      return GigOfferChatMessage.fromServer(message as LX.GigOfferChatMessage)
    case MessageTypes.ROOM_CLOSED:
      return RoomClosedChatMessage.fromServer(message as LX.RoomClosedChatMessage)
    case MessageTypes.GIG_DISPUTE:
      return GigDisputeChatMessage.fromServer(message as LX.GigDisputeChatMessage)
    case MessageTypes.GIG_REVIEW:
      return GigReviewChatMessage.fromServer(message as LX.GigReviewChatMessage)
    case MessageTypes.GIG_REFUNDED:
      return GigRefundedChatMessage.fromServer(message as LX.GigRefundedChatMessage)
    case MessageTypes.USER_BAN:
      return UserBannedChatMessage.fromServer(message as LX.UserBannedChatMessage)
    case MessageTypes.GIG_MARK_IS_DONE:
      return GigMarkedDoneChatMessage.fromServer(message as LX.GigMarkedDoneChatMessage)
    case MessageTypes.JOB_MARK_IS_DONE:
      return JobMarkedDoneChatMessage.fromServer(message as LX.JobMarkedDoneChatMessage)
    case MessageTypes.JOB_DISPUTE:
      return JobDisputeChatMessage.fromServer(message as LX.JobDisputeChatMessage)
    case MessageTypes.JOB_REFUNDED:
      return JobRefundedChatMessage.fromServer(message as LX.JobRefundedChatMessage)
    case MessageTypes.JOB_REVIEW:
      return JobReviewChatMessage.fromServer(message as LX.JobReviewChatMessage)
    case MessageTypes.JOB_REMOVED:
    case MessageTypes.JOB_UNPUBLISHED:
      return JobUnavailableChatMessage.fromServer(message as LX.JobUnavailableChatMessage)
    case MessageTypes.JOB_ROOM_UNLOCKED:
      return JobRoomUnlockedChatMessage.fromServer(message as LX.JobRoomUnlockedChatMessage)
    case MessageTypes.VACANCY_REMOVED:
    case MessageTypes.VACANCY_UNPUBLISHED:
      return VacancyUnavailableChatMessage.fromServer(message as LX.VacancyUnavailableChatMessage)
    case MessageTypes.VACANCY_APPLICATION_APPLIED:
      return VacancyApplicationAppliedChatMessage.fromServer(message as LX.VacancyApplicationAppliedChatMessage)
    case MessageTypes.VACANCY_APPLICATION_DECLINED_BY_CUSTOMER:
    case MessageTypes.VACANCY_APPLICATION_DECLINED_BY_FREELANCER:
      return VacancyApplicationDeclinedChatMessage.fromServer(message as LX.VacancyApplicationDeclinedChatMessage)
    case MessageTypes.VACANCY_ARCHIVED:
      return VacancyArchivedChatMessage.fromServer(message as LX.VacancyArchivedChatMessage)
    case MessageTypes.GIG_UNPUBLISHED:
    case MessageTypes.GIG_REMOVED:
      return GigUnavailableChatMessage.fromServer(message as LX.GigUnavailableChatMessage)
    default:
      return SystemChatMessage.fromServer(message as LX.SystemChatMessage)
  }
}
